import { render, staticRenderFns } from "./NewsFeatured.vue?vue&type=template&id=78e50ca6"
import script from "./NewsFeatured.vue?vue&type=script&lang=js"
export * from "./NewsFeatured.vue?vue&type=script&lang=js"
import style0 from "./NewsFeatured.vue?vue&type=style&index=0&id=78e50ca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports